import React from 'react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/modules/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper.scss';
import Calculator from './Calculator';
import CalculatorData from './CalculatorData';
import CalculatorDataFr from './CalculatorDataFr';
import useWindowDimensions from './WindowDimensions';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  extendedClasses: {
    marginTop: '16px',
    marginBottom: '32px',
  },
  swiperslide: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '32px',
  },
  section: {
    paddingBottom: '32px',
    paddingTop: '32px',
    marginBottom: '16px',
    ['@media(max-width:576px)']: {
      paddingBottom: '20px',
      paddingBottom: '20px',
      paddingTop: '20px',
    },
  },
  lastDiv: {
    justifyContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
  },
});
function CalculatorsSection(props) {
  const classes1 = useStyles();
  const { t } = useTranslation();
  SwiperCore.use([Pagination]);

  const { height, width } = useWindowDimensions();
  let calculators;
  if (props.selectedLang === 'fr') {
    calculators = CalculatorDataFr;
  } else {
    calculators = CalculatorData;
  }

  let toRender;

  if (width <= 509) {
    toRender = (
      <Swiper
        slidesPerView={1}
        centeredSlides
        direction="horizontal"
        pagination={{ clickable: true }}
      >
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[1]}
              id={calculators[1].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[0]}
              id={calculators[0].name}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[2]}
              id={calculators[2].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[3]}
              id={calculators[3].name}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[4]}
              id={calculators[4].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[5]}
              id={calculators[5].name}
            />
          </div>
        </SwiperSlide>
      </Swiper>
    );
  }

  if (width <= 770 && width >= 510) {
    toRender = (
      <Swiper
        slidesPerView={2}
        direction="horizontal"
        pagination={{ clickable: true }}
      >
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[0]}
              id={calculators[0].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[1]}
              id={calculators[1].name}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[2]}
              id={calculators[2].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[3]}
              id={calculators[3].name}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[4]}
              id={calculators[4].name}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[5]}
              id={calculators[5].name}
            />
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <div className={`item ${classes1.swiperslide}`}>
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[1]}
            />
            <Calculator
              className={classes1.extendedClasses}
              calculator={calculators[0]}
            />
          </div>
        </SwiperSlide> */}
      </Swiper>
    );
  }

  return (
    <>
      <section id="calculatorsSection" className={classes1.section}>
        <Container fixed>
          <div className="section-title">
            <h2 id="calculators">
              {t('sections-CalcSection-CalcSection-Title')}
            </h2>
            <p> {t('sections-CalcSection-CalcSection-Para')}</p>
          </div>
          <div>
            <p
              className=" calculator-heading-description"
              style={{ margin: '0px' }}
            >
              {t('sections-CalcSection-CalcSection-HeadDesc')}
            </p>
          </div>
        </Container>
        <Container fixed>
          {width <= 770 ? (
            toRender
          ) : (
            <div className={`calculators ${classes1.lastDiv}`}>
              {calculators.map((calculator, i) => {
                return <Calculator calculator={calculator} key={i} />;
              })}
            </div>
          )}
        </Container>
      </section>
    </>
  );
}

export default CalculatorsSection;
